import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import { observable } from 'mobx';
import { addMinutes, isBefore } from 'date-fns';

/**
 * A range of time
 */
var TimeRange = (_class = /*#__PURE__*/function () {
  function TimeRange(startTime, endTime) {
    _classCallCheck(this, TimeRange);
    _initializerDefineProperty(this, "startTime", _descriptor, this);
    _initializerDefineProperty(this, "endTime", _descriptor2, this);
    this.startTime = startTime;
    this.endTime = endTime;
  }
  return _createClass(TimeRange, [{
    key: "isEqual",
    value: function isEqual(range) {
      return range.startTime.getHours() === this.startTime.getHours() && range.startTime.getMinutes() === this.startTime.getMinutes() && range.endTime.getHours() === this.endTime.getHours() && range.endTime.getMinutes() === this.endTime.getMinutes();
    }
  }, {
    key: "decomposeRangeInIntervals",
    value: function decomposeRangeInIntervals(intervalInMinutes) {
      var cursor = new Date(this.startTime);
      var intervals = [];
      while (isBefore(cursor, this.endTime)) {
        var end = addMinutes(cursor, intervalInMinutes);
        intervals.push(new TimeRange(cursor, end));
        cursor = end;
      }
      return intervals;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "startTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "endTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TimeRange as default };
//# sourceMappingURL=TimeRange.js.map
